import React, { useEffect, useReducer, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import _ from 'lodash'
import initializeHelperText from 'utilities/helperText.js'
import WizardHeader from 'components/VirtualPortal/components/WizardHeader'
import GenericErrorModal from 'components/VirtualPortal/components/ErrorModal'
import WishlistRow from './WishlistRow.js'
import './wishlist.css'

const listReducer = (state, action) => {
  switch (action.type) {
  case 'INITIALIZE': {
    const list = action.list
    return { ...state, list: list, blockTotal: action.blockTotal, includeTotal: action.includeTotal }
  }
  case 'UPDATE_ITEM': {
    const newList = state.list.map((item) => {
      if (action.status === 'delete' && item.id === action.surveyUser.id) {
        const updatedItem = {
          ...item,
          wishlist_id: null,
          blocked_status: null,
        }
        return updatedItem
      } else if (action.results && item.id === action.results.impacted_survey_user_id) {
        const updatedItem = {
          ...item,
          wishlist_id: action.results.id,
          blocked_status: action.results.is_blocked,
        }
        return updatedItem
      }
      return item
    })
    let count = _.countBy(newList, l => l.blocked_status)
    return { ...state, list: newList, blockTotal: count.true || 0, includeTotal: count.false || 0 }
  }
  default:
    console.log('ruh roh')
  }
}

const Wishlist = () => {
  const params = useParams()
  const history = useHistory()
  const { token } = params
  const [errorModalIsOpen, setErrorModalIsOpen] = useState(false)
  const [errorStatus, genericModalStatus] = useState('')
  const [errorMessage, genericErrorModalMessage] = useState('')
  const [searchTerms, updateSearchTerms] = useState('')
  const [saving, setSaving] = useState(false)

  // listData is current state, dispatchListData is a function used to 'dispatch' an action
  // userReducer has two args - reducer function, initial states of things
  const [listData, dispatchListData] = useReducer(listReducer, {
    list: null,
    blockTotal: 0,
    includeTotal: 0
  })

  useEffect(() => {
    initializeHelperText()
    window.api.get('/virtual_portal/wishlist_users').then((response) => {
      let blockTotal = 0
      let includeTotal = 0
      if(response.data.users.length > 0) {
        response.data.users.forEach((surveyUser) => {
          if (surveyUser.blocked_status) {
            blockTotal += 1
          } else if (surveyUser.blocked_status === false) {
            includeTotal += 1
          }
        })
      }
      dispatchListData({
        type: 'INITIALIZE',
        list: response.data.users,
        blockTotal: blockTotal,
        includeTotal: includeTotal
      })
    }).catch(() => {})
  }, [])

  function genericErrorModal(openLiveChat = false) {
    setErrorModalIsOpen(true)
    genericModalStatus('Error')
    genericErrorModalMessage('Sorry, something went wrong. Please refresh the page.')
    if(openLiveChat && window.LiveChatWidget){
      window.expandLiveChat()
    }
  }

  function toggleWishlistButtonStatus(surveyUser, e) {
    const currentUserSurveyUserId = surveyUser.current_survey_user_id
    let block = e.currentTarget.getAttribute('data')
    // if survey user block status is null, create a wishlist and block or not
    if(surveyUser.blocked_status === null) {
      const data = { event_one_on_one_meeting_wishlist:
        {
          is_blocked: block,
          survey_user_id: currentUserSurveyUserId,
          impacted_survey_user_id: surveyUser.id
        }
      }
      window.api.post('/virtual_portal/create_event_one_on_one_meeting_wishlists', data).then((response) => {
        let results = response.data.event_one_on_one_meeting_wishlist
        dispatchListData({ type: 'UPDATE_ITEM', status: 'new', results })
      }).catch(() => {
        genericErrorModal()
      })
    } else if(surveyUser.blocked_status.toString() === block) {
      // if survey user block status is false and block is false, delete wishlist
      // if survey user block status is true and block is true, delete wishlist
      window.api.delete('/virtual_portal/delete_event_one_on_one_meeting_wishlists/' + surveyUser.wishlist_id)
      dispatchListData({ type: 'UPDATE_ITEM', status: 'delete', surveyUser })
    } else if(surveyUser.blocked_status.toString() !== block) {
      // if survey user block status is false and block is true, update wishlist
      // if survey user block status is true and block is false, update wishlist
      const data = { event_one_on_one_meeting_wishlist:
        {
          is_blocked: block,
          survey_user_id: currentUserSurveyUserId,
          impacted_survey_user_id: surveyUser.id
        }
      }
      window.api.put('/virtual_portal/update_event_one_on_one_meeting_wishlists/' + surveyUser.wishlist_id, data).then((response) => {
        let results = response.data.event_one_on_one_meeting_wishlist
        dispatchListData({ type: 'UPDATE_ITEM', status: 'update', results })
      }).catch(() => {
        genericErrorModal()
      })
    }
  }

  function filterWishlist(searchTerms) {
    let surveyUsers = listData.list
    if(searchTerms !== '') {
      if(surveyUsers) {
        surveyUsers = surveyUsers.filter((su) => {
          let searchableText =
            `${ su.user.first_name } ` +
            `${ su.user.last_name } ` +
            `${ su.user.organization_name } `
          searchableText = searchableText.toLowerCase()
          return searchableText.indexOf(searchTerms.toLowerCase()) >= 0
        })
      }
    }
    return surveyUsers
  }

  function getWishlistRows() {
    if(listData.list !== null ) {
      let rows = []
      let index = 0
      filterWishlist(searchTerms).map((surveyUser) => {
        index ++
        rows.push(
          <WishlistRow
            key={surveyUser.id}
            surveyUser={surveyUser}
            onBlockedStatusChange={toggleWishlistButtonStatus}
            relevanceScore={index}
          />
        )
      })
      return rows
    } else {
      return <div>No participants to display.</div>
    }
  }

  if(window.LiveChatWidget) {
    if(params.wizard) {
      window.LiveChatWidget.call('hide')
    } else {
      window.LiveChatWidget.call('minimize')
    }
  }

  function submit(direction) {
    setSaving(true)
    let endpoint = params.wizard ? '/wishlist_rank/wizard' : ''
    if(direction === 'forward'){
      history.push('/' + token + endpoint)
    } else {
      history.push('/' + token + '/profile/wizard')
    }
  }

  return (
    <div className='wizard-form wishlist-page'>
      <WizardHeader
        wizard={params.wizard}
        activeTab='wishlist'/>
      <h3>Make your meeting selections for this event</h3>
      <div className='wishlist-legend'>
        <p>Please select your top candidates for meetings. The more options you select, the more likely we can match you with a like-minded peer.</p>
        <p>Please note that you are creating a list of preferred meeting partners, but we cannot guarantee that your choices will result in scheduled meetings.</p>
        <div className="input-group">
          <span className="input-group-prepend">
            <div className="input-group-text bg-transparent border-right-0"><i className="fa fa-search"></i></div>
          </span>
          <input className='search-filter form-control border-left-0' placeholder="Search by Organization or Name" value={searchTerms} onChange={ e => updateSearchTerms(e.currentTarget.value) } />
        </div>
        <div className='wishlist-legend-grid'>
          <span className='wishlist-legend-col'><i className='fa fa-thumbs-o-up'></i><em> = Add participant to list of potential meetings</em></span>
          <span className='wishlist-legend-col'><i className='fa fa-thumbs-o-down'></i><em> = Remove participant and be hidden from their list</em></span>
        </div>
      </div>
      <div className='wishlist-grid-container'>
        <div className='wishlist-grid-header-row'>
          <div className='wishlist-grid-header'>
            <span>Include ({listData.includeTotal}) / Block ({listData.blockTotal})</span>
            { errorModalIsOpen &&
              <GenericErrorModal
                toggleModal={genericErrorModal}
                isOpen={errorModalIsOpen}
              >
                <h5>{errorStatus}</h5>
                <hr/>
                <h6>{errorMessage}</h6>
              </GenericErrorModal>
            }
          </div>
          <div className='wishlist-grid-header'><span>Organization</span></div>
          <div className='wishlist-grid-header'><span>Name</span></div>
          <div className='wishlist-grid-header title-col'><span>Title</span></div>
          <div className='wishlist-grid-header'><span>Relevance Rank<i className='fa fa-question helper-text' data-content="We’ve calculated your most relevant meeting partners based on our matching criteria." rel='popover' data-placement='bottom' data-trigger='hover'></i></span></div>
          <div className='wishlist-grid-header'></div>
        </div>
        <div className='wishlist-grid-content-container'>
          {getWishlistRows()}
        </div>
      </div>
      <div className='bottom-buttons margin-top-10'>
        { params.wizard ?
          <button onClick={ () => submit('backward') } className='submit previous'>
              SAVE & PREVIOUS
          </button>
          : '' }
        <button
          onClick={ () => submit('forward') }
          className='submit'>
          { saving ? (<i className="fa fa-refresh fa-spin"></i>) : ''}
          { params.wizard ? 'SAVE & CONTINUE' : 'SAVE'}
        </button>
      </div>
    </div>
  )
}

export default Wishlist
